import { useMemo } from "react";
import { Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { sidebarItems } from "../../navigation/sidebar.config";
import { getUser } from "../../utils/storage";
import "./Sidebar.css";

const { Sider } = Layout;

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();

  // Filter sidebar items based on user's RBAC permissions
  const visibleItems = useMemo(() => {
    if (!user?.permissions) return sidebarItems;

    return sidebarItems.filter((item) => {
      const modulePerms = user.permissions[item.module];
      return modulePerms?.view !== false;
    });
  }, [user]);

  // Match active key — find the sidebar item whose key is a prefix of current path
  const selectedKey = useMemo(() => {
    const match = visibleItems
      .slice()
      .sort((a, b) => b.key.length - a.key.length)
      .find((item) => location.pathname.startsWith(item.key));
    return match?.key || "/dashboard";
  }, [location.pathname, visibleItems]);

  return (
    <Sider width={256} className="app-sidebar">
      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        items={visibleItems}
        onClick={({ key }) => navigate(key)}
        rootClassName="sidebar-menu"
      />
    </Sider>
  );
}
